import PropTypes from "prop-types";
import sanitize from "sanitize-html";

import { AnswerWrapper, AnswerContent, AnswerImage } from "./Answer.style";

export const Answer = (props) => {
  return (
    <AnswerWrapper
      number={String.fromCharCode(65 + props.index)}
      onClick={() => props.onSelect(props)}
      selected={props.selected}
      disabled={props.disabled}
      correct={props.answer_value}
    >
      <AnswerContent
        selected={props.selected}
        dangerouslySetInnerHTML={{
          __html: sanitize(props.answer_content || "", {
            allowedTags: ["p"],
          }),
        }}
      />
      {props.image && <AnswerImage src={props.image} alt="" />}
    </AnswerWrapper>
  );
};

Answer.propTypes = {
  index: PropTypes.number,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  image_size: PropTypes.string,
  answer_content: PropTypes.string,
  answer_value: PropTypes.bool,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};
